import React, { useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const PHONE = '5492966244076';
const MESSAGE = 'Hola! Vengo de la página de Código de Emergencia Escolar Nivel Primario y quiero ayuda con mi pago. ¿Me podrías asesorar?';
const waUrl = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;
export function WhatsAppFloat() {
  const [showTooltip, setShowTooltip] = useState(true);
  return <div className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-[9998] flex items-end gap-2" data-id="element-225">
      <AnimatePresence data-id="element-226">
        {showTooltip && <motion.div initial={{
        opacity: 0,
        x: 10,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: 10,
        scale: 0.9
      }} transition={{
        duration: 0.25
      }} className="relative bg-white rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.15)] px-3 py-2 mb-1 hidden sm:block" data-id="element-227">
            <p className="text-[13px] font-poppins font-bold text-[#1B3A6B] whitespace-nowrap" data-id="element-228">
              ¿Dudas con tu pago? Escribime.
            </p>
            <button onClick={() => setShowTooltip(false)} aria-label="Cerrar" className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-[#1B3A6B] text-white text-[10px] flex items-center justify-center hover:bg-[#0F2347] transition-colors" data-id="element-229">
              ×
            </button>
            <div className="absolute top-1/2 -right-1.5 -translate-y-1/2 w-3 h-3 bg-white rotate-45" data-id="element-230" />
          </motion.div>}
      </AnimatePresence>

      <motion.a href={waUrl} target="_blank" rel="noopener noreferrer" aria-label="Hablar por WhatsApp" animate={{
      scale: [1, 1.06, 1]
    }} transition={{
      duration: 2.4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} whileHover={{
      scale: 1.1
    }} whileTap={{
      scale: 0.95
    }} style={{
      willChange: 'transform',
      boxShadow: '0 4px 15px rgba(37,211,102,0.4)'
    }} className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] hover:bg-[#1FAD55] flex items-center justify-center transition-colors" data-id="element-231">
        <svg className="w-7 h-7 md:w-8 md:h-8 fill-white" viewBox="0 0 24 24" aria-hidden="true" data-id="element-232">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-233" />
        </svg>
      </motion.a>
    </div>;
}